
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/2063d56d77349d69e524f0264c628611/2688fc0842963eeefc13622e94263b94.png"
              alt="S2K Waste Services"
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#home"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Home
            </a>
            <a
              href="#about"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              About
            </a>
            <a
              href="#services"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Services
            </a>
            <a
              href="#contact"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Contact
            </a>
          </div>

          <div className="flex items-center space-x-4">
            <a
              href="#quote"
              className="px-6 py-2.5 bg-orange-500 text-white text-sm font-semibold rounded-full hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Get a Quote
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
